/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneGhostInput/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import "DesignSystem/Fonts/Inter-500.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneGhostInput({
  children,
  viewPath = "/DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostInput",
  inputRef,
  autoComplete = "off",
  autoFocus,
  type = "text",
  tabIndex,
  color,
  width = "100%",
  placeholder,
  onChangeFilter,
  onBlur,
  onFocus,
  onKeyUp,
  valueFilter,
  disabled,
  hovered,
  selectedPlaceholder,
  optionValue,
  size
  
}) {
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let colorOrdtColorsNeutral600 = color ?? dtColorsNeutral600
  return (<React.Fragment
>
<input
 type={
                type === 'phone' ? 'tel' :
                type === 'secure' ? 'password' : type}
inputMode={type === 'number' || type === 'phone'? "numeric" : undefined}
pattern={type === 'number' || type === 'phone'? "[0-9]*" : undefined}
  data-testid="TysiaSelectOneGhostInput.Capture"
  data-view-path={viewPath}
 ref={inputRef}
 autoComplete={autoComplete}
 autoFocus={autoFocus}
 tabIndex={tabIndex}
 placeholder={selectedPlaceholder ? selectedPlaceholder : placeholder}
 onChange={(e) => onChangeFilter && onChangeFilter(e, e.target.value)}
 onBlur={onBlur}
 onFocus={onFocus}
 onKeyUp={onKeyUp}
 value={optionValue ? optionValue : valueFilter}
 disabled={disabled}
 style={{'--w-4-Z1u4Ufn': typeof width === 'number' ? `${width}px` : width,'--c-1-Z1u4Ufn': hovered && !disabled ? dtColorsNeutral700 : disabled ? dtColorsNeutral400 : colorOrdtColorsNeutral600,'--c-5-Z1u4Ufn': disabled ? "not-allowed" : "pointer",'--fs-2-Z1u4Ufn': size == "small" ? "12px" : size === "tiny" ? "11px" : "13px",'--lh-3-Z1u4Ufn': size == "small" ? "16px" : size === "tiny" ? "14px" : "20px"}}
 className={`views-capture ${styles.Capture}`}
/>
{children}
</React.Fragment>)
}